import { render } from "./IncongruityDefectPage.vue?vue&type=template&id=2d2630f9"
import script from "./IncongruityDefectPage.vue?vue&type=script&lang=js"
export * from "./IncongruityDefectPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__